import { apiSlice } from "api/apiSlice";
import { format } from 'date-fns';
import fr from "date-fns/locale/fr/";
import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";

const rolesTable = {"7":"Administrator", "6":"Manager", "5":"Editor", "3": "Distributeur", "1" :"Visitor"};
export const convertRoles = (rolesObj) => {
    if(!rolesObj) return  ["Visitor",['Visitor']];
    const roles = Object.values(rolesObj).filter(Boolean);
    const firstDigitStr = String(Math.max(...roles))[0];
    return [rolesTable[firstDigitStr], Object.keys(rolesObj).filter(Boolean)] ;
}

const usersAdapter = createEntityAdapter({})

const initialState = usersAdapter.getInitialState({
    usersDetails : {
        page: 0,
        filters: {},
        usersPerpage: 20,
        total_results: 0
    }
})

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUsers: builder.query({
            query: params =>( { url:'/users', params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedUsers = responseData.users ? responseData.users.map( user => {

                    const modifiedUser = {
                        id : user.id, 
                        email : user.email,
                        displayName : user.displayName,
                        phone : user.phone,
                        roles : convertRoles(user.roles),
                        banned : Number(user.active) === 1 ? true : false,
                        date   : format(Date.parse(user.createdAt) , 'dd MMM yyyy\tHH:mm', {locale:fr}),
                        photoURL : user.photoURL,
                        profileId : null
                    }
                    
                    return modifiedUser;
                }) : [];

                return usersAdapter.upsertMany( usersAdapter.getInitialState({
                    usersDetails : {page: responseData.page,
                    filters: responseData.filters ,
                    usersPerpage: responseData.usersPerpage,
                    total_results: responseData.total_results}
                }), loadedUsers)
            },
             /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'User', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'User', id }))
                    ]
                } 
                return [{ type: 'User', id: 'LIST' }]
            }
        }),
        getTagsUsers: builder.query({
            query: params =>( { url:'/users/tags', params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedUsers = responseData.map(user => {
                     /* eslint-disable */
                    user.id = user._id
                    return user
                });
                return usersAdapter.setAll(initialState, loadedUsers)
            },
             /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'User', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'User', id }))
                    ]
                } 
                return [{ type: 'User', id: 'LIST' }]
            }
        }),
        getUser: builder.query({
            query: id =>( { url:`/user/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const modifiedUser = {
                    id : responseData.user.id, 
                    email : responseData.user.email,
                    displayName : responseData.user.displayName,
                    phone : responseData.user.phone,
                    roles : convertRoles(responseData.user.roles),
                    banned : responseData.user.active === 1 ? true : false,
                    date   : format(Date.parse(responseData.user.createdAt) , 'dd MMM yyyy\tHH:mm', {locale:fr}),
                    photoURL : responseData.user.photoURL,
                    birthdate : responseData.user.birthdate,
                    gender : responseData.user.gender,
                    location : responseData.user.location,
                    job : responseData.user.job,
                    bio : responseData.user.bio,
                    social : responseData.user.social
                }
                
                return modifiedUser;
            },
             /* eslint-disable */
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'User', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'User', id }))
                    ]
                } 
                return [{ type: 'User', id: 'LIST' }]
            }
        }),
        addNewUser: builder.mutation({
            query: initialUserData => ({
                url: '/users',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'User', id: "LIST" }
            ]
        }),
        
        updateUser: builder.mutation({
            query: initialProfileData => ({
                url: '/users',
                method: 'PATCH',
                body: {
                    ...initialProfileData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'User', id: arg.id }
            ]
        }),
        updateProfil : builder.mutation({
            query: initialProfileData => ({
                url: '/users/profil',
                method: 'PATCH',
                body: {
                    ...initialProfileData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'User', id: arg.id }
            ]
        }),
        updateProfilePhoto: builder.mutation({
            query: initialProfileData => ({
                url: '/profile/upload',
                method: 'POST',
                body: initialProfileData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'User', id: arg.id }
            ]
        }),
        deleteProfilePhoto: builder.mutation({
            query: initialProfileData => ({
                url: '/profile/upload',
                method: 'DELETE',
                body: initialProfileData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'User', id: arg.id }
            ]
        }),
        deleteUser: builder.mutation({
            query: ({ id }) => ({
                url: `/user`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'User', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetUsersQuery,
    useGetUserQuery,
    useLazyGetUsersQuery,
    useGetTagsUsersQuery,
    useLazyGetTagsUsersQuery,
    useAddNewUserMutation,
    useUpdateUserMutation,
    useUpdateProfilMutation,
    useUpdateProfilePhotoMutation,
    useDeleteProfilePhotoMutation,
    useDeleteUserMutation,
} = usersApiSlice

// returns the query result object
export const selectUsersResult = usersApiSlice.endpoints.getUsers.select()

// creates memoized selector
const selectUsersData = createSelector(
    selectUsersResult,
    usersResult => usersResult.data // normalized state object with ids & entities
)

// getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll : selectAllUsers,
    selectById: selectUserById,
    selectIds : selectUserIds
    // Pass in a selector that returns the users slice of state
} = usersAdapter.getSelectors(state => selectUsersData(state) ?? initialState)